module.exports = __webpack_public_path__ + "static/img/eighth_bg2.6704ce91.png";